import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { NavigationEnd, NavigationStart, Router, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { filter } from 'rxjs/operators'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { dark_theme, light_theme, paper_theme } from 'src/app/ngrx/store/actions'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { AppState } from '../../../ngrx/states'
import { Themes } from '../../enums/enums'
import { DdcLogoComponent } from '../ddc-logo/ddc-logo.component'

@Component({
  selector: 'ddc-public-navbar',
  templateUrl: './ddc-public-navbar.component.html',
  styleUrls: ['./ddc-public-navbar.component.scss'],
  imports: [AngularMaterialsModules, CommonModule, RouterModule, DdcLogoComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcPublicNavbarComponent {
  _theme: string
  _navbarMessage: string
  _marqueeText: string = `Welcome to Daydic !
  Your AI-Native Learning Platform.
  Generate quizzes, flashcards, figures, dictionaries, flashcards, matching games, and so much more!
   Lingo AI help you learn faster and smarter!
   Upgrade to Pro for unlimited access and personalized learning.`

  constructor(
    private logger: DdcLoggerService,
    private store: Store<AppState>,
    public themeService: ThemeService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.initTheme()
  }

  initTheme(): void {
    this.logger.info('DdcPublicNavbarComponent initTheme()')
    this._theme = this.themeService.currentTheme
    this.onThemeChipChange(this._theme)
    this.setNavbarMessage()
  }

  setNavbarMessage(): void {
    this.logger.info('DdcPublicNavbarComponent setNavbarMessage()')

    this.router.events
      .pipe(
        filter((event: any) => event instanceof NavigationStart || event instanceof NavigationEnd),
      )
      .subscribe((event: any) => {
        if (event instanceof NavigationStart) {
          // Check the current route and set showNavbar accordingly
          if (event.url === '/signup') {
            this._navbarMessage = '  Welcome to Daydic'
          } else if (event.url === '/login') {
            this._navbarMessage = '  Your AI-Native Learning Platform'
          } else if (event.url === '/verification') {
            this._navbarMessage = '  Just One More Thing...'
          } else if (event.url === '/find_account') {
            this._navbarMessage = "  Lost? We'll Find You!"
          } else if (event.url.startsWith('/reset_password/')) {
            this._navbarMessage = '  Reset Your Password'
          }
        }
      })
  }

  //TODO fix error NG0100:ExpressionChangedAfterItHasBeenCheckedError
  onThemeChipChange(value: string): void {
    this.logger.info('DdcPublicNavbarComponent onThemeChipChange() value:', value)
    this._theme = value

    if (value === Themes.DARK) {
      this.store.dispatch(dark_theme())
      this.themeService.set(Themes.DARK)
    } else if (value === Themes.LIGHT) {
      this.store.dispatch(light_theme())
      this.themeService.set(Themes.LIGHT)
    } else if (value === Themes.PAPER) {
      this.store.dispatch(paper_theme())
      this.themeService.set(Themes.PAPER)
    } else {
      this.store.dispatch(light_theme())
      this.themeService.set(Themes.LIGHT)
    }
  }
}
